// 获取年级及班级
import request from '@/plugin/axios';

export function getSchoolInfoById(params) {
  return request({
    url: '/baseApi/school/getSchoolInfoById',
    method: 'post',
    data: params
  });
}

export function getGradeClassList(params) {
  return request({
    url: '/baseApi/class/getGradeClassList',
    method: 'get',
    params
  });
}

export function getClassListByPlan(params) {
  return request({
    url: '/baseApi/class/getClassListByPlan',
    method: 'get',
    params
  });
}

export function getPlanCourseList(params) {
  return request({
    url: '/baseApi/course/getPlanCourseList',
    method: 'get',
    params
  });
}

export function getSubjectList(params) {
  return request({
    url: '/baseApi/subject/getSubjectList',
    method: 'get',
    params
  });
}

export function getUserList(params) {
  return request({
    url: '/baseApi/user/getUserList',
    method: 'get',
    params
  });
}

export function getPlanList(params) {
  return request({
    url: '/baseApi/plan/getPlanList',
    method: 'get',
    params
  });
}

export function addPlan(params) {
  return request({
    url: '/baseApi/plan/addPlan',
    method: 'post',
    data: params
  });
}

export function updatePlan(params) {
  return request({
    url: '/baseApi/plan/updatePlan',
    method: 'post',
    data: params
  });
}

export function deletePlan(params) {
  return request({
    url: '/baseApi/plan/deletePlan',
    method: 'post',
    data: params
  });
}

export function addCourse(params) {
  return request({
    url: '/baseApi/course/addCourse',
    method: 'post',
    data: params
  });
}

export function getPlanInfoByClass(params) {
  return request({
    url: '/baseApi/plan/getSectionListByPlan',
    method: 'get',
    params
  });
}

export function getLeaderCoursePower(params) {
  return request({
    url: '/baseApi/userRole/getLeaderCoursePower',
    method: 'get',
    params
  });
}

export function addCoursePowerToLeader(params) {
  return request({
    url: '/baseApi/userRole/addCoursePowerToLeader',
    method: 'post',
    data: params
  });
}

export function deleteCoursePowerToLeader(params) {
  return request({
    url: '/baseApi/userRole/deleteCoursePowerToLeader',
    method: 'post',
    data: params
  });
}

export function updateNotice(params) {
  return request({
    url: '/baseApi/notice/updateNotice',
    method: 'post',
    data: params
  });
}

export function getNoticeStatus(params) {
  return request({
    url: '/baseApi/notice/getNoticeStatus',
    method: 'get',
    params
  });
}
